import {
  IStorageNodeProviderCreateRequest,
  IStorageNodeProviderDetailItem,
  IStorageNodeProviderFind,
  IStorageNodeProviderListItem,
  IStorageNodeProviderUpdateRequest,
} from "api/entities/storage-node-providers";
import { DataService } from "./data-service";
import { IPage } from "api/entities/page";

class StorageNodeProviderService extends DataService {
  constructor() {
    super("storage-node-provider", 2);
  }

  async getPage(
    requestParams: IStorageNodeProviderFind
  ): Promise<IPage<IStorageNodeProviderDetailItem>> {
    const page = await this.api.get<IPage<IStorageNodeProviderListItem>>(
      null,
      requestParams
    );
    // Temporary. change when implementing CRUD ops
    const providers = await Promise.all(page.data.map((item) => this.get(item.id)));

    return {
      count: providers.length,
      data: providers,
    }
  }

  async getDefaults(): Promise<IStorageNodeProviderListItem[]> {
    return (await this.getPage({ default: true })).data;
  }

  async get(providerId: string): Promise<IStorageNodeProviderDetailItem> {
    return this.api.get<IStorageNodeProviderDetailItem>(providerId);
  }

  async create(
    request: IStorageNodeProviderCreateRequest
  ): Promise<IStorageNodeProviderDetailItem> {
    return this.api.post<IStorageNodeProviderDetailItem>(null, request);
  }
  async update(
    id: string,
    request: IStorageNodeProviderUpdateRequest
  ): Promise<IStorageNodeProviderDetailItem> {
    return this.api.put<IStorageNodeProviderDetailItem>(id, request);
  }

  async delete(providerId: string): Promise<string> {
    return this.api.delete<string>(providerId);
  }
}

export const storageNodeProviderService = new StorageNodeProviderService();
